import { Card } from 'antd';
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import { Menu } from 'antd';
import './settings.scss';
import Profile from './profile/profile';
import SocialAccountsTab from '../social-accounts-tab/social-accounts-tab';
import EmailNotifications from './email-notifications/email-notifications';
import { useTranslation } from 'react-i18next';

const Settings = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentKey = () => {
    const path = location.pathname.split('/').pop();
    return path || 'profile';
  };

  const menuItems = [
    {
      label: t('settings.tabs.profile'),
      key: 'profile',
    },
    {
      label: t('settings.notifications.title'),
      key: 'email-notifications',
    },
  ];

  return (
    <Card className="settings">
      <Menu
        mode="horizontal"
        selectedKeys={[getCurrentKey()]}
        onClick={({ key }) => navigate(`/settings/${key}`)}
        items={menuItems}
      />

      <div style={{ padding: '10px 0' }}>
        <Routes>
          <Route path="profile" element={<Profile />} />
          <Route path="email-notifications" element={<EmailNotifications />} />
          <Route path="" element={<Navigate to="profile" replace />} />
        </Routes>
      </div>
    </Card>
  );
};

export default Settings;
